import { createContext } from 'react'
import type { HealthResponse } from './types'

export interface HealthState {
  health: HealthResponse | null
  loading: boolean
  error: string | null
}

export const HealthCtx = createContext<HealthState>({
  health: null,
  loading: true,
  error: null,
})
